export default "/react/calltouchIcon-1c5e6da9.svg";